import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import industries_1 from '../../assets/images/industries_1.jpg';
import industries_2 from '../../assets/images/industries_2.jpg';
import industries_3 from '../../assets/images/industries_3.jpg';
import industries_4 from '../../assets/images/industries_4.jpg';
import industries_5 from '../../assets/images/industries_5.jpg';
import industries_6 from '../../assets/images/industries_6.jpg';
import industries_7 from '../../assets/images/industries_7.jpg';
import industries_8 from '../../assets/images/industries_8.jpg';
import industries_9 from '../../assets/images/industries_9.jpg';
import industries_10 from '../../assets/images/industries_10.jpg';
import industries_11 from '../../assets/images/industries_11.gif';
import industries_12 from '../../assets/images/industries_12.jpg';
import industries_17 from '../../assets/images/industries_17.jpg';
import industries_16 from '../../assets/images/industries_16.jpg';
import industries_22 from '../../assets/images/industries_22.jpg';
import industries_20 from '../../assets/images/industries_20.jpg';
import industries_24 from '../../assets/images/industries_24.jpg';
import industries_27 from '../../assets/images/industries_27.jpg';
import industries_28 from '../../assets/images/industries_28.jpg';
import industries_30 from '../../assets/images/industries_30.jpg';
import industries_19 from '../../assets/images/industries_19.jpg';
import industries_21 from '../../assets/images/industries_21.jpg';

const IndustriesContent = styled('div')({
  padding: '20px',
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
});

const IndustriesItemContent = styled('div')(({ isRtl }) => ({
  display: 'flex',
  gap: '20px',
  //   alignItems: 'center',
  //   gridTemplateColumns: '1fr 1fr',
  //   gap: '40px',
  //   alignItems: 'center',
  //   margin: '40px 0',
  // backgroundColor: 'gray',
  direction: isRtl ? 'rtl' : 'ltr',
  '@media (max-width: 768px)': {
    // gridTemplateColumns: '1fr',
    gap: '20px',
  },
}));

const ImageContainer = styled('div')({
  width: '230px',
  height: '200px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  borderRadius: '5px',
  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.02)',
  },
});

const Applications = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const marker = isRtl ? 'كيف ندعم هذه الصناعة:' : 'How We Support This Industry:';

  const commonTextStyles = {
    color: 'rgb(154,74,32)',
    // fontFamily: isRtl ? 'Arial, sans-serif' : 'inherit',
    textAlign: isRtl ? 'right' : 'left',
    width: '100%',
  };

  const contentStyles = {
    width: '100%',
    display: 'flex',
    alignItems: isRtl ? 'flex-end' : 'flex-start',
    flexDirection: 'column',
    gap: '5px',
  };

  const imageStyles = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    transition: 'transform 0.3s ease',
  };

  const titleStyles = {
    ...commonTextStyles,
    fontSize: '24px',
    // marginBottom: '5px',
    margin: '0px',
    fontWeight: '500',
    color: '#7f6001',
  };

  const descriptionStyles = {
    ...commonTextStyles,
    fontSize: '16px',
    lineHeight: '1.6',
    fontWeight: '400',
    opacity: '0.9',
    margin: '0px',
    color: 'black',
  };

  const industries = [
    {
      image: industries_17,
      titleKey: 'industries.animalFeed.title',
      descriptionKey: 'industries.animalFeed.description',
    },
    {
      image: industries_24,
      titleKey: 'industries.agriculturalFertilizerIndustry.title',
      descriptionKey: 'industries.agriculturalFertilizerIndustry.description',
    },
    {
      image: industries_30,
      titleKey: 'industries.petroleumAndGasIndustry.title',
      descriptionKey: 'industries.petroleumAndGasIndustry.description',
    },
    {
      image: industries_19,
      titleKey: 'industries.glassIndustry.title',
      descriptionKey: 'industries.glassIndustry.description',
    },
    {
      image: industries_12,
      titleKey: 'industries.steel.title',
      descriptionKey: 'industries.steel.description',
    },
    {
      image: industries_20,
      titleKey: 'industries.paintIndustry.title',
      descriptionKey: 'industries.paintIndustry.description',
    },
    {
      image: industries_3,
      titleKey: 'industries.plastics.title',
      descriptionKey: 'industries.plastics.description',
    },
    {
      image: industries_22,
      titleKey: 'industries.constructionMaterials.title',
      descriptionKey: 'industries.constructionMaterials.description',
    },
    {
      image: industries_1,
      titleKey: 'industries.cement.title',
      descriptionKey: 'industries.cement.description',
    },
    {
      image: industries_28,
      titleKey: 'industries.foodIndustry.title',
      descriptionKey: 'industries.foodIndustry.description',
    },
    {
      image: industries_21,
      titleKey: 'industries.rubber.title',
      descriptionKey: 'industries.rubber.description',
    },
    {
      image: industries_16,
      titleKey: 'industries.pharmaceutical.title',
      descriptionKey: 'industries.pharmaceutical.description',
    },
    // {
    //   image: industries_7,
    //   titleKey: 'industries.chemical.title',
    //   descriptionKey: 'industries.chemical.description'
    // },
    {
      image: industries_27,
      titleKey: 'industries.paper.title',
      descriptionKey: 'industries.paper.description',
    },
  ];

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        direction: isRtl ? 'rtl' : 'ltr',
        padding: '40px 0',
      }}
    >
      <IndustriesContent>
        <Typography
          variant="h4"
          component="h4"
          sx={{
            ...commonTextStyles,
            fontSize: '32px',
            margin: '0 0 0px',
            fontWeight: '600',
            textAlign: 'center',
          }}
        >
          {t('industries.mainTitle')}
        </Typography>
        <div
          style={{
            textAlign: 'center',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="i"
            component="i"
            sx={{
              color: '#7f5e1f',
              fontWeight: '400',
              width: '68%',
              textAlign: 'center',
              margin: '0 0 60px',
              textAlign: 'center',
              direction: 'ltr'
            }}
          >
            {/* {t('banner.subSlogan')} */}
            "Every great industry begins with a strong foundation. The raw
            materials we supply are more than just products—they are the first
            vital steps in building, shaping, and sustaining large-scale
            industries worldwide."
          </Typography>
        </div>

        {industries.map((industry, index) => {
          const description = t(industry.descriptionKey);
          const [before, after] = description.split(marker);
          return (
            <div style={{ marginBottom: '20px' }}>
              <IndustriesItemContent key={index} isRtl={isRtl}>
                <ImageContainer>
                  <img
                    src={industry.image}
                    alt={t(industry.titleKey)}
                    style={imageStyles}
                    loading="lazy"
                  />
                </ImageContainer>

                <div style={contentStyles}>
                  <h4 style={titleStyles}>{t(industry.titleKey)}</h4>
                  <p style={{ ...descriptionStyles, whiteSpace: 'pre-line' }}>
                    {before}
                    {marker && (
                      <span
                        style={{ color: '#7f6001', fontWeight: '800' }}
                      >
                        {marker}
                      </span>
                    )}
                    {after}
                  </p>
                </div>
              </IndustriesItemContent>
            </div>
          );
        })}
      </IndustriesContent>
    </Box>
  );
};

export default Applications;
